import { PublicClientApplication } from '@azure/msal-browser';
import Button from '@mui/material/Button';
import React from 'react';

const ButtonMicrosoftSSO = ({ strategy, onSubmit, onError, loading }) => {
  const handleClick = async () => {
    const publicClientApplication = new PublicClientApplication({
      auth: {
        clientId: strategy.config.clientId,
        redirectUri: `${window.location.origin}/login`,
        authority: `https://login.microsoftonline.com/${strategy.config.tenant}/`
      },
      cache: {
        cacheLocation: 'sessionStorage'
      }
    });

    try {
      await publicClientApplication
        .loginPopup({
          scope: ['user.read'],
          prompt: 'select_account'
        })
        .then((resp) => {
          onSubmit({
            email: resp.account.username,
            idToken: resp.idToken
          });
        })
        .catch((error) => error);
    } catch (error) {
      const message = 'Error login AzuresAD SSO';
      onError({ message });
    }
  };

  return (
    <Button
      variant='outlined'
      color='inherit'
      className='w-full border-muted'
      size='large'
      disabled={loading}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          cursor: 'pointer',
        },
        '&:disabled': {
          cursor: 'not-allowed',
        },
      }}
    >
      <div className='flex items-center justify-start'>
        <div className='btn-icon btn-icon-microsoft'></div>
        <div className='text-icon initial-case'>{strategy.label ?? 'Sign in with Microsoft'} </div>
      </div>
    </Button>
  );
};

export default ButtonMicrosoftSSO;
